import React, { useEffect } from "react";

// Components imports
import SelectElement from "../SelectElement";
import InputField from "../InputField";

// Scss imports
import css from "./Filter.module.scss";

interface FilterProps {
  text?: string;
  onSelectDocumentTypeChange?: any;
  filterArray?: any;
  onSelectCategoryChange?: any;
  categoryArray?: any;
  setFilteredSubnumber: Function;
  onSelectArchivedChange?: any;
  archivedArray?: any;
  onSelectProcessorChange?: any;
  processorArray?: any;
  setCategoryListArray?: any;
  categoriesArray?: any;
  activeProcessors?: any;
  setProcesorsListArray?: any;
  baseNumber?: string;
  recipientSenderArray?: any;
  onSelectRecipientSenderChange?: any;
  setRecipientsSendersListArray?: any;
  recipientsSendersListArray?: any;
  setFilteredByDateOfCreation?: any;
  setCreatedAtFrom?: any;
  setCreatedAtTo?: any;
  filteredByDateOfCreation?: any;
  createdAtFrom?: any;
  createdAtTo?: any;
  senderDateFrom?: any;
  senderDateTo?: any;
  filteredBySenderDate?: any;
  setSenderDateFrom?: any;
  setSenderDateTo?: any;
  setFilteredBySenderDate?: any;
  setFilteredSenderPaperNumber?: any;
  setFilteredShortText?: any;
  sortByDateArray?: any;
  onSelectSortByDateChange?: any;
  setFilteredSort?: any;
  type?: string;
  setFilteredNumberOfPapers?: any;
  setFilteredRemark?: any;
  setFilteredShelfLifeFrom?: any;
  setFilteredShelfLifeTo?: any;

  onSelectActivityChange?: any;
  activityArray?: any;
  onSelectRoleChange?: any;
  roleArray?: any;
  setFilteredFirstName?: any;
  setFilteredLastName?: any;
  setFilteredPlace?: any;
  setFilteredBusinessName?: any;
}

const Filter: React.FC<FilterProps> = ({
  onSelectDocumentTypeChange,
  filterArray,
  onSelectCategoryChange,
  categoryArray,
  setFilteredSubnumber,
  onSelectArchivedChange,
  archivedArray,
  onSelectProcessorChange,
  processorArray,
  setCategoryListArray,
  categoriesArray,
  activeProcessors,
  setProcesorsListArray,
  baseNumber,
  recipientSenderArray,
  onSelectRecipientSenderChange,
  setRecipientsSendersListArray,
  recipientsSendersListArray,
  setFilteredByDateOfCreation,
  setCreatedAtFrom,
  setCreatedAtTo,
  filteredByDateOfCreation,
  createdAtFrom,
  createdAtTo,
  senderDateFrom,
  senderDateTo,
  filteredBySenderDate,
  setSenderDateFrom,
  setSenderDateTo,
  setFilteredBySenderDate,
  setFilteredSenderPaperNumber,
  setFilteredShortText,
  sortByDateArray,
  onSelectSortByDateChange,
  setFilteredSort,
  type,
  setFilteredNumberOfPapers,
  setFilteredRemark,
  setFilteredShelfLifeFrom,
  setFilteredShelfLifeTo,
  onSelectActivityChange,
  activityArray,
  onSelectRoleChange,
  roleArray,
  setFilteredFirstName,
  setFilteredLastName,
  setFilteredPlace,
  setFilteredBusinessName,
}) => {
  useEffect(() => {
    if (setFilteredByDateOfCreation) {
      setFilteredByDateOfCreation(createdAtFrom + createdAtTo);
    }
  }, [createdAtFrom, createdAtTo]);

  useEffect(() => {
    if (setFilteredByDateOfCreation) {
      setFilteredBySenderDate(senderDateFrom + senderDateTo);
    }
  }, [senderDateFrom, senderDateTo]);

  useEffect(() => {
    // From categories array get array for showing categories
    const catArr =
      categoriesArray && categoriesArray.length > 0
        ? categoriesArray.map((element) => {
            return {
              value: element._id,
              name: element.name,
              categoryNumber: element.baseNumber,
            };
          })
        : [];

    if (type !== "allUsers") {
      setCategoryListArray([{ value: "", name: "Изабери" }, ...catArr]);
    }

    if (type === "papers") {
      // From active processors array get array for showing categories
      const processorsListArray =
        activeProcessors.data && activeProcessors.data.length > 0
          ? activeProcessors.data.map((element) => {
              return {
                value: `&processor=${element._id}`,
                name: element.firstName + " " + element.lastName,
              };
            })
          : "";
      setProcesorsListArray([
        { value: "", name: "Изабери" },
        ...processorsListArray,
      ]);

      // From recipients and senders array get array for showing recipient/senders options
      const recipientSendersListArray =
        recipientSenderArray && recipientSenderArray.length > 0
          ? recipientSenderArray.map((element) => {
              return {
                value: `&recipientSender[regex]=${element.recSendName}`,
                name: element.recSendName,
              };
            })
          : "";
      setRecipientsSendersListArray([
        { value: "", name: "Изабери" },
        ...recipientSendersListArray,
      ]);
    }

    // categoryListArray.unshift({ value: "", name: "Изабери категорију" });
  }, []);
  return (
    <div>
      <div className={css.container}>
        {type === "papers" ? (
          <div className={css.selectWrapper}>
            <SelectElement
              label="Тип документа"
              id="documentType"
              name="documentType"
              handleChange={(e) => onSelectDocumentTypeChange(e)}
              selectOptionsArray={filterArray}
              minLabelWidth={true}
              type="filterSelect"
            />
          </div>
        ) : (
          ""
        )}
        {type === "papers" ? (
          <div className={css.selectWrapper}>
            <SelectElement
              label="Архивирано"
              id="archived"
              name="archived"
              handleChange={(e) => onSelectArchivedChange(e)}
              selectOptionsArray={archivedArray}
              minLabelWidth={true}
              type="filterSelect"
            />
          </div>
        ) : (
          ""
        )}
        {type !== "allUsers" ? (
          <>
            <SelectElement
              label="Категорија"
              id="category"
              name="category"
              handleChange={(e) => onSelectCategoryChange(e)}
              selectOptionsArray={categoryArray}
              minLabelWidth={true}
              type="filterSelect"
            />
            <div className={css.selectWrapper}>
              <InputField
                label="о.б"
                name="baseNumber"
                id="baseNumber"
                type="number"
                value={baseNumber}
                placeholder=""
                //value={baseNumber}
                //handleChange={handleChange}
                handleOnFocus={(e: any) => (e.target.placeholder = "")}
                handleOnBlur={(e: any) => (e.target.placeholder = "483483")}
                disabled={true}
                inputType="filterInput"

                //errorText={errorBaseNumberText}
                //onInputHandler={onInputBaseNumber}
              />
            </div>

            <div className={css.selectWrapper}>
              <InputField
                label="Подброј"
                name="subnumber"
                id="subnumber"
                type="text"
                handleChange={(e: any) => {
                  if (type === "papers") {
                    if (e.target.value.length > 0) {
                      setFilteredSubnumber(`&subnumber=${e.target.value}`);
                    } else {
                      setFilteredSubnumber("");
                    }
                  } else {
                    if (e.target.value.length > 0) {
                      setFilteredSubnumber(`&subnumbers=${e.target.value}`);
                    } else {
                      setFilteredSubnumber("");
                    }
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Кратак садржај"
                name="shortText"
                id="shortText"
                type="text"
                handleChange={(e: any) => {
                  if (type === "papers") {
                    if (e.target.value.length > 0) {
                      setFilteredShortText(
                        `&shortText[regex]=${e.target.value}`
                      );
                    } else {
                      setFilteredShortText("");
                    }
                  } else {
                    if (e.target.value.length > 0) {
                      setFilteredShortText(`&content[regex]=${e.target.value}`);
                    } else {
                      setFilteredShortText("");
                    }
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
          </>
        ) : (
          ""
        )}
        {type === "papers" ? (
          <div className={css.selectWrapper}>
            <SelectElement
              label="Обрађивач"
              id="processor"
              name="processor"
              handleChange={(e) => onSelectProcessorChange(e)}
              selectOptionsArray={processorArray}
              minLabelWidth={true}
              type="filterSelect"
            />
          </div>
        ) : (
          ""
        )}
        {type !== "allUsers" && (
          <>
            {" "}
            <div className={css.selectWrapper}>
              <InputField
                label="Креирано од"
                name="createdAtFrom"
                id="createdAtFrom"
                type="date"
                handleChange={(e: any) =>
                  setCreatedAtFrom(`&createdAt[gte]=${e.target.value}`)
                }
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Креирано до"
                name="createdAtTo"
                id="createdAtTo"
                type="date"
                handleChange={(e: any) => {
                  setCreatedAtTo(`&createdAt[lte]=${e.target.value}`);
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
          </>
        )}
        {type === "papers" ? (
          <div className={css.selectWrapper}>
            <SelectElement
              label="Пошиљалац/Прималац"
              id="recipientSender"
              name="recipientSender"
              handleChange={(e) => onSelectRecipientSenderChange(e)}
              selectOptionsArray={recipientsSendersListArray}
              minLabelWidth={true}
              type="filterSelect"
            />
          </div>
        ) : (
          ""
        )}

        {type === "papers" ? (
          <>
            <div className={css.selectWrapper}>
              <InputField
                label="Датум акта пошиљаоца од"
                name="senderDateFrom"
                id="senderDateFrom"
                type="date"
                handleChange={(e: any) =>
                  setSenderDateFrom(`&senderDate[gte]=${e.target.value}`)
                }
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Датум акта пошиљаоца до"
                name="senderDateTo"
                id="senderDateTo"
                type="date"
                handleChange={(e: any) => {
                  setSenderDateTo(`&senderDate[lte]=${e.target.value}`);
                }}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Број акта пошиљаоца"
                name="senderPaperNumber"
                id="senderPaperNumber"
                type="text"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredSenderPaperNumber(
                      `&senderPaperNumber[regex]=${e.target.value}`
                    );
                  } else {
                    setFilteredSenderPaperNumber("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
          </>
        ) : (
          ""
        )}
        {type === "archive" ? (
          <>
            <div className={css.selectWrapper}>
              <InputField
                label="Број докумената"
                name="numberOfPapers"
                id="numberOfPapers"
                type="number"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredNumberOfPapers(
                      `&numberOfPapers=${e.target.value}`
                    );
                  } else {
                    setFilteredNumberOfPapers("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Напомена"
                name="remark"
                id="remark"
                type="string"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredRemark(`&remark[regex]=${e.target.value}`);
                  } else {
                    setFilteredRemark("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Рок чувања од"
                name="shelfLifeTo[gte]"
                id="shelfLifeTo[gte]"
                type="number"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredShelfLifeTo(
                      `&shelfLifeTo[gte]=${e.target.value}`
                    );
                  } else {
                    setFilteredShelfLifeTo("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Рок чувања до"
                name="shelfLifeTo[lte]"
                id="shelfLifeTo[lte]"
                type="number"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredShelfLifeTo(
                      `&shelfLifeTo[lte]=${e.target.value}`
                    );
                  } else {
                    setFilteredShelfLifeTo("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
          </>
        ) : (
          ""
        )}

        {type === "allUsers" ? (
          <>
            <div className={css.selectWrapper}>
              <SelectElement
                label="Активност"
                id="active"
                name="active"
                handleChange={(e) => onSelectActivityChange(e)}
                selectOptionsArray={activityArray}
                minLabelWidth={true}
                type="filterSelect"
              />
            </div>
            <div className={css.selectWrapper}>
              <SelectElement
                label="Улога"
                id="role"
                name="role"
                handleChange={(e) => onSelectRoleChange(e)}
                selectOptionsArray={roleArray}
                minLabelWidth={true}
                type="filterSelect"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Име"
                name="firstName"
                id="firstName"
                type="text"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredFirstName(`&firstName[regex]=${e.target.value}`);
                  } else {
                    setFilteredFirstName("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Презиме"
                name="lastName"
                id="lastName"
                type="text"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredLastName(`&lastName[regex]=${e.target.value}`);
                  } else {
                    setFilteredLastName("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Пословно име"
                name="businessName"
                id="businessName"
                type="text"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredBusinessName(
                      `&businessName[regex]=${e.target.value}`
                    );
                  } else {
                    setFilteredBusinessName("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
            <div className={css.selectWrapper}>
              <InputField
                label="Место"
                name="place"
                id="place"
                type="text"
                handleChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    setFilteredPlace(`&place[regex]=${e.target.value}`);
                  } else {
                    setFilteredPlace("");
                  }
                }}
                minLabelWidth={true}
                inputType="filter"
              />
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      {/* Sorting */}
      <hr className={css.shine} />

      {type !== "allUsers" && (
        <div className={css.selectWrapper}>
          <SelectElement
            label="Сортирај по датуму креирања"
            id="sort"
            name="sort"
            handleChange={(e) => onSelectSortByDateChange(e)}
            selectOptionsArray={sortByDateArray}
            minLabelWidth={true}
            type="filterSelect"
          />
        </div>
      )}

      {type === "allUsers" && (
        <div className={css.selectWrapper}>
          <SelectElement
            label="Сортирај по датуму претплате"
            id="sort"
            name="sort"
            handleChange={(e) => onSelectSortByDateChange(e)}
            selectOptionsArray={sortByDateArray}
            minLabelWidth={true}
            type="filterSelect"
          />
        </div>
      )}
    </div>
  );
};

export default Filter;
